import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[10%] left-[40%] w-[250px] h-[250px] rounded-full blur-[100px]"
          style={{ background: 'var(--danger-bg)' }}
        />
      </div>
      <div className="relative">
        <h1 className="text-[8rem] md:text-[10rem] font-black select-none pointer-events-none leading-none"
          style={{ color: 'var(--text-muted)' }}
        >
          404
        </h1>
        <div className="relative z-10 -mt-12">
          <h2 className="text-xl md:text-2xl font-semibold" style={{ color: 'var(--text-primary)' }}>Page not found</h2>
          <p className="mt-2 text-sm font-mono" style={{ color: 'var(--text-muted)' }}>{location.pathname}</p>
          <Link
            to="/dashboard"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 text-sm rounded-xl transition-all"
            style={{ background: 'var(--bg-surface-raised)', border: '1px solid var(--border-primary)', color: 'var(--text-secondary)' }}
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
